(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-duo-picker"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.getElementById('sn-duo-form');
  if (!form) return;

  var state = { 1: null, 2: null };

  var propEls = {
    1: document.getElementById('sn-prop-1'),
    2: document.getElementById('sn-prop-2')
  };

  var cnameEls = {
    1: document.getElementById('sn-cname-1'),
    2: document.getElementById('sn-cname-2')
  };

  var miniDotEls = {
    1: document.getElementById('sn-mini-1'),
    2: document.getElementById('sn-mini-2')
  };

  var atcBtn = document.getElementById('sn-duo-atc');
  var msgEl = document.getElementById('sn-duo-msg');

  function selectColor(btn, slot) {
    var color = btn.dataset.color;
    var hex = btn.dataset.hex;

    form.querySelectorAll('.sn-duo__swatch[data-slot="' + slot + '"]').forEach(function (s) {
      s.classList.remove('is-selected');
      s.setAttribute('aria-pressed', 'false');
    });

    btn.classList.add('is-selected');
    btn.setAttribute('aria-pressed', 'true');

    state[slot] = color;
    if (propEls[slot]) propEls[slot].value = color;
    if (cnameEls[slot]) cnameEls[slot].textContent = color;

    if (miniDotEls[slot]) {
      miniDotEls[slot].style.backgroundColor = hex;
      miniDotEls[slot].hidden = false;
    }

    var ready = state[1] !== null && state[2] !== null;
    atcBtn.disabled = !ready;
    atcBtn.setAttribute('aria-disabled', String(!ready));
    if (ready) msgEl.hidden = true;
  }

  form.addEventListener('click', function (e) {
    var btn = e.target.closest('.sn-duo__swatch');
    if (!btn || btn.classList.contains('is-sold-out')) return;
    selectColor(btn, parseInt(btn.dataset.slot, 10));
  });

  form.addEventListener('submit', function (e) {
    if (!state[1] || !state[2]) {
      e.preventDefault();
      msgEl.hidden = false;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.sn-hero').forEach(function(section) {
      const headlines = section.querySelectorAll('.sn-hero__headline');
      if (headlines.length < 2) return;
      const ms = parseInt(section.dataset.rotationMs, 10) || 4000;
      let current = 0;
      setInterval(function() {
        headlines[current].classList.remove('is-active');
        current = (current + 1) % headlines.length;
        headlines[current].classList.add('is-active');
      }, ms);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
